export default __webpack_public_path__ + "static/media/38.5d8c4ae3.png";